import { OrderProduct, Section } from '../../orderProducts.types';
import { emptyClassification } from '../orderProductsHelpers.utils';
import OrderProductsBuilder, { OrderProductsGroupProps } from './OrderProductsGroupBuilder';

class OrderProductsGroupByColorClassifications extends OrderProductsBuilder {
  public group({ orderProducts, info }: OrderProductsGroupProps): Section[] {
    const groupedProductsMap = new Map<string, Set<OrderProduct>>();
    const noClassificationGroup = new Set<OrderProduct>();

    orderProducts.forEach((product) => {
      let hasClassification = false;
      product.colorClassifications?.forEach((classification) => {
        if (classification.classificationType.id === (info?.classificationTypeId?.[0] || '')) {
          hasClassification = true;
          const classificationId = classification.id;
          const existingGroup = groupedProductsMap.get(classificationId) || new Set<OrderProduct>();
          existingGroup.add(product);
          groupedProductsMap.set(classificationId, existingGroup);
        }
      });

      if (!hasClassification) {
        noClassificationGroup.add(product);
      }
    });

    const groupedSections: Section[] = [];
    groupedProductsMap.forEach((productsSet, classificationId) => {
      const products = Array.from(productsSet);
      const { colorClassifications } = products[0];
      const currentClassification = colorClassifications?.find(
        (classification) => classification.id === classificationId,
      );
      groupedSections.push({
        products,
        isExpanded: true,
        productsCount: products.length,
        colorClassification: currentClassification,
      });
    });

    if (noClassificationGroup.size > 0) {
      groupedSections.push({
        isExpanded: true,
        productsCount: noClassificationGroup.size,
        products: Array.from(noClassificationGroup),
        colorClassification: emptyClassification,
      });
    }

    return groupedSections;
  }
}

export default OrderProductsGroupByColorClassifications;
